<template>
    <div class="svg-icon-wrapper">
        <div class="svg-icon" :alt="svgName">
            <ClientOnly>
                <slot v-if="!props.svgActive || (props.svgActive && !$slots.active)" />
                <slot v-else-if="$slots.active" name="active" />
                <template #fallback>
                    <slot v-if="!props.svgActive || (props.svgActive && !$slots.active)" />
                    <slot v-else-if="$slots.active" name="active" />
                </template>
            </ClientOnly>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type {CommonIconProps} from './common-props';

    const props = withDefaults(defineProps<CommonIconProps>(), {
        svgSize: 18,
        svgColor: 'var(--joy-color-neutral-60)',
    });
</script>

<style lang="scss" scoped>
    .svg-icon-wrapper {
        height: calc(v-bind(svgSize) * 1px);
        width: calc(v-bind(svgSize) * 1px);
        color: v-bind(svgColor);
        position: relative;
        display: inline-block;
        flex: 0 0 auto;

        .svg-icon {
            position: absolute;
            height: 100%;
            width: 100%;
            inset: 0;

            :deep(svg) {
                height: 100%;
                width: 100%;
            }
        }
    }
</style>
